<template>
<div>
    <Breadcrumbs main="Admin" title="What We Do" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header header-mobile">

                        <router-link to="/admin/what-we-do/new">
                            <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New What We Do</h7>
                            </button>
                        </router-link>

                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </div>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="overflow: hidden;">
                                <b-table show-empty stacked="md" :items="what_we_do_lists" :fields="tablefields" :current-page="currentPage" :filter="filter" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img :src="host+row.item.image" alt="" style="height: 80px;">
                                        </div>
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title">
                                            <p>{{ row.item.title }}</p>
                                        </div>
                                    </template>
                                    <template #cell(type)="row">
                                        <div v-if="row.item.type">
                                            <router-link :to="{ name: 'what-we-do-create', params: { type: row.item.type }}" class="link-style">
                                                {{ getTypeText(row.item.type) }}
                                            </router-link>
                                        </div>
                                    </template>
                                    <template #cell(custom)="data">
                                        <span v-if="data.item.custom == true" class="d-flex flex-column justify-content-center">
                                            <b-badge v-b-tooltip.hover title="Toggle" variant="primary" @click="toggleCustom(data.item.slug)" style="cursor: pointer; max-width: fit-content;">Yes</b-badge>
                                            <router-link :to="`/admin/custom-what-we-do/${data.item.type}`">
                                                <b-badge v-b-tooltip.hover variant="primary"> Details </b-badge>
                                            </router-link>
                                        </span>
                                        <span v-if="data.item.custom == false">
                                            <router-link :to="`/admin/custom-what-we-do/${data.item.type}`">
                                                <b-badge v-b-tooltip.hover variant="danger"> No </b-badge>
                                            </router-link>
                                        </span>

                                    </template>

                                    <template #cell(short)="row">
                                        <div v-if="row.item.short !== null" style="max-width: 300px;">
                                            {{ truncateText(row.item.short,40) }}
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteWhatWeDo(data.item.id)" title="Delete"></feather>
                                            <router-link :to="{ name: 'what-we-do-create', params: { type: data.item.type }}">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                            </router-link>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this what we do?</div>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import js from '../../../auth/js';
import {
    myHost
} from '../../../_helpers/host'
import loader from '../loader/loader.vue'
export default {
    components: {
        loader,
    },
    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: true
                },

                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'short',
                    label: 'Short Description',
                    sortable: true
                },

                {
                    key: 'custom',
                    label: 'Custom',
                    sortable: true
                },
              

                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            filter: null,
            delete_value: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            what_we_do_lists: state => state.whatWeDo.what_we_do,
            loading: state => state.whatWeDo.what_we_do_Loading,
            error: state => state.whatWeDo.what_we_do_Error,
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {

        this.$store.dispatch("whatWeDo/fetchWhatDo").then(() => {

            this.items = this.what_we_do_lists
            this.totalRows = this.items.length;

        });

    },

    watch: {

    },

    methods: {
        toggleCustom(data) {
            this.$store.dispatch("whatWeDo/whatDoCustomToggle", {
                what_we_do_slug: data
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.udate_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
        getTypeText(type) {
            switch (type) {
                case 'research':
                    return 'Research';
                case 'advocacy':
                    return 'Advocacy';
                case 'sdgs':
                    return 'SDGS';
                case 'citizen_engagement':
                    return 'Citizen Engagement';
                case 'stakeholder_engagement':
                    return 'Stakeholder Engagement';
                default:
                    return '';
            }
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        resetModal() {
            this.selectedStatus = ''
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        deleteWhatWeDo(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("whatWeDo/deleteWhatDo", {
                delete: this.delete_value,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
